import styled from "styled-components";
import { colors } from "@styles/colors";

export const $FunnelPageFooterClickable = styled.span`
  cursor: pointer;
  color: ${colors.primaryBase};
`;
